import { keepPreviousData, useQuery } from "@tanstack/react-query";
import merchantDetailProvider, {
	type MerchantDetail,
} from "src/providers/merchant-detail-provider";

export function useMerchantDetail(
	merchantUuid: string | undefined,
	startDate: string,
	endDate: string,
) {
	return useQuery<MerchantDetail>({
		queryKey: ["merchant-detail", merchantUuid, startDate, endDate],
		queryFn: () => {
			if (!merchantUuid) {
				return Promise.reject(new Error("merchant id required"));
			}
			return merchantDetailProvider.get(merchantUuid, startDate, endDate);
		},
		enabled: !!merchantUuid,
		staleTime: 30_000,
		placeholderData: keepPreviousData,
	});
}
